import React from 'react';
import './App.css';
import { beginTest } from './utils/run-tests';

export class App extends React.Component {
    componentDidMount() {
        beginTest();
    }

    render() {
        return (
            <div className="App">
                <div id="contentbox">
                    <div id="progressbox" role="none">
                        <div id="friendlybox" role="main" />
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
